var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EuiContainer',[_c('TemplateParapherShow',{attrs:{"parapher":_vm.parapher},on:{"goBack":function($event){return _vm.$router.go(-1);}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }